import { __ } from '@wordpress/i18n'
import React, { useState, useEffect } from 'react'
import { gsap } from 'gsap'
import apiFetch from '@wordpress/api-fetch'
import './styles.scss'

export default function MoreArticlesTeaserBlock({
  title,
  articleID1,
  customArticle1,
  imageArticle1,
  titleArticle1,
  exerptArticle1,
  permalink_urlArticle1,
  permalinkArticle1,
  bubbles1,
  permalinkTarget1,
  articleID2,
  customArticle2,
  imageArticle2,
  titleArticle2,
  exerptArticle2,
  permalink_urlArticle2,
  permalinkArticle2,
  bubbles2,
  permalinkTarget2,
  articleID3,
  customArticle3,
  imageArticle3,
  titleArticle3,
  exerptArticle3,
  permalink_urlArticle3,
  permalinkArticle3,
  bubbles3,
  permalinkTarget3,
}) {
  return (
    <div className={'dhsv-more-articles-block'}>
      <div className={'row'}>
        <div className={'col-12'}>
          {title && (
            <h5 className={'more-articles__title'} data-scroll>
              {title}
            </h5>
          )}
        </div>
      </div>
      <div className={'row'}>
        <div className={'col-12 col-md-4'}>
          {customArticle1 ? (
            <CustomPost
              classname={'article-post article-post--first'}
              img={imageArticle1}
              title={titleArticle1}
              exerpt={exerptArticle1}
              permalink_url={permalink_urlArticle1}
              permalink={permalinkArticle1}
              bubbles={bubbles1}
              permalink_target={permalinkTarget1}
            />
          ) : (
            articleID1 && (
              <ArticlesPost
                classname={'article-post article-post--first'}
                id={articleID1}
                permalink_target={permalinkTarget1}
              />
            )
          )}
        </div>
        <div className={'col-12 col-md-4'}>
          {customArticle2 ? (
            <CustomPost
              classname={'article-post article-post--second'}
              img={imageArticle2}
              title={titleArticle2}
              exerpt={exerptArticle2}
              permalink_url={permalink_urlArticle2}
              permalink={permalinkArticle2}
              bubbles={bubbles2}
              permalink_target={permalinkTarget2}
            />
          ) : (
            articleID2 && (
              <ArticlesPost
                classname={'article-post article-post--second'}
                id={articleID2}
                permalink_target={permalinkTarget2}
              />
            )
          )}
        </div>
        <div className={'col-12 col-md-4'}>
          {customArticle3 ? (
            <CustomPost
              classname={'article-post article-post--third'}
              img={imageArticle3}
              title={titleArticle3}
              exerpt={exerptArticle3}
              permalink_url={permalink_urlArticle3}
              permalink={permalinkArticle3}
              bubbles={bubbles3}
              permalink_target={permalinkTarget3}
            />
          ) : (
            articleID3 && (
              <ArticlesPost
                classname={'article-post article-post--third'}
                id={articleID3}
                permalink_target={permalinkTarget3}
              />
            )
          )}
        </div>
      </div>
    </div>
  )
}

const CustomPost = ({
  img,
  classname,
  title,
  exerpt,
  permalink_url,
  permalink,
  permalink_target,
  bubbles,
}) => {
  return (
    <a
      href={permalink_url}
      className={classname}
      data-scroll
      target={`${permalink_target ? '_blank' : '_self'}`}
    >
      {bubbles && (
        <div className="preview">
          <svg
            className="preview-back"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 0 0"
          ></svg>
          <div className="preview-body"></div>
        </div>
      )}
      <div className={'article-post__img-wrap'}>
        <ImageTag id={img} />
      </div>
      <h5
        className={'article-post__title'}
        dangerouslySetInnerHTML={{ __html: title }}
      />
      {typeof exerpt === 'string' ? (
        <>
          <p
            dangerouslySetInnerHTML={{ __html: exerpt }}
            className={'article-post__excerpt'}
          />
          <span className="article-post__permalink">{__(permalink)}</span>
        </>
      ) : (
        <>
          <p className={'article-post__excerpt'}>{exerpt}</p>
          <span className="article-post__permalink">{__(permalink)}</span>
        </>
      )}
    </a>
  )
}

const ImageTag = ({ id }) => {
  const [imgData, setImgData] = useState({})
  useEffect(() => {
    apiFetch({ path: '/wp-json/wp/v2/media/' + id }).then(data => {
      setImgData(data)
    })
  }, [id])
  return imgData.source_url ? <img src={imgData.source_url} /> : false
}

const ArticlesPost = ({ id, classname, permalink_target }) => {
  const [postData, setPostData] = useState({
    info: {
      thumbnail: '',
      title: '',
      excerpt: '',
      permalink: '',
    },
  })
  const current_lang = $('html').attr('lang')
  const permalink_text = current_lang === 'de-DE' ? 'Mehr' : 'More'

  useEffect(() => {
    apiFetch({ path: '/wp-json/wp/v2/article/' + id }).then(data => {
      setPostData({
        info: {
          thumbnail: data.info.thumbnail,
          title: data.info.title,
          excerpt: data.info.excerpt,
          permalink: data.info.permalink,
        },
      })
    })
  }, [id])

  useEffect(() => {
    const previews = Array.from(document.querySelectorAll('.preview'))

    if (!window.isRenderedOnce) {
      console.log('bubbles') //eslint-disable-line
      if (!previews[0].classList.contains('test')) {
        previews[0].classList.add('test')

        previews.forEach(p => {
          // console.log(p)
          const previewBodyEl = p.querySelector('.preview-body')
          // const previewBodyEl = p.querySelector('.article-post')
          const previewBackEl = p.querySelector('.preview-back')

          // Set size for the preview elements
          const elWidth = p.offsetWidth
          const elHeight = p.offsetHeight
          const paddingSides = 100 // bubble space sides
          const padding = 95 // bubble space
          const transTop = -85 // Top Translation
          const transSides = -50 // Sides Translation
          gsap.set(previewBodyEl, {
            width: elWidth,
            height: elHeight,
          })
          gsap.set(previewBackEl, {
            top: transTop,
            left: transSides,
            width: elWidth + paddingSides,
            height: elHeight + padding * 0.65,
          })

          // Generate bubbles coordinates
          const density = 0.05
          let bubbles = []
          const numBubbles = Math.floor((elWidth + elHeight) * density)
          let overlapping = false
          let cnt = 0
          let circle, randX, randY, radius

          if (numBubbles) {
            while (bubbles.length < numBubbles && cnt < 200) {
              radius = 5 + Math.random() * 20

              if (Math.random() > 0.5) {
                randX = radius + Math.random() * (padding - radius)
                if (Math.random() > 0.5) randX += elWidth + padding - radius
                randY =
                  radius + Math.random() * (elHeight + padding - radius * 2)
              } else {
                randY = radius + Math.random() * (padding - radius)
                if (Math.random() > 0.5) randY += elHeight + padding - radius
                randX =
                  radius + Math.random() * (elWidth + padding - radius * 2)
              }

              circle = {
                x: randX,
                y: randY,
                r: radius,
              }
              overlapping = false

              // check that it is not overlapping with any existing circle
              // another brute force approach
              for (let i = 0; i < bubbles.length; i++) {
                const d = dist(circle.x, circle.y, bubbles[i].x, bubbles[i].y)
                if (d * 0.5 < circle.r + bubbles[i].r) {
                  overlapping = true
                  break
                }
              }

              if (!overlapping) {
                bubbles.push(circle)
              }
              cnt++
            }
          }

          function dist(x1, y1, x2, y2) {
            return Math.sqrt(Math.pow(x2 - x1, 2) + Math.pow(y2 - y1, 2))
          }

          // Draw bubbles
          gsap.set(previewBackEl, {
            attr: {
              viewBox:
                '0 0 ' +
                (elWidth + 2 * padding) +
                ' ' +
                (elHeight + 2 * padding),
            },
          })
          let circleEls = []

          if (bubbles.length > 0) {
            bubbles.forEach(bObj => {
              const circleEl = document.createElementNS(
                'http://www.w3.org/2000/svg',
                'circle'
              )
              if (previewBackEl && circleEl) {
                previewBackEl.appendChild(circleEl)
                gsap.set(circleEl, {
                  attr: { cx: bObj.x, cy: bObj.y, r: bObj.r },
                  opacity: 0,
                })
                circleEls.push(circleEl)
              }
            })
          }
          // Rise bubbles by event
          let backgroundVisible = false
          if (previewBodyEl) {
            previewBodyEl.addEventListener('mouseenter', riseBubbles)
            // previewBodyEl.addEventListener('mousemove', riseBubbles)
            previewBodyEl.addEventListener('click', riseBubbles)
            previewBodyEl.addEventListener('mouseleave', removeBubbles)
          }

          function riseBubbles() {
            console.log('rise') //eslint-disable-line
            if (!backgroundVisible) {
              bubbles.forEach((bObj, bubbleIdx) => {
                const dur = 0.1 + 0.3 * Math.random()
                gsap.from(circleEls[bubbleIdx], {
                  duration: dur,
                  scale: 0.6,
                  transformOrigin: 'center center',
                  ease: 'back(5).out',
                })
                gsap.to(circleEls[bubbleIdx], {
                  duration: 0.2,
                  delay: 0.5 * dur,
                  scale: 1,
                  opacity: 1,
                })
                backgroundVisible = true
              })
            }
          }

          function removeBubbles() {
            console.log('remove') //eslint-disable-line

            bubbles.forEach((bObj, bubbleIdx) => {
              const dur = 0.1 + 0.3 * Math.random()
              gsap.from(circleEls[bubbleIdx], {
                // duration: dur,
                scale: 0,
                transformOrigin: 'center center',
                // ease: 'back(5).out',
              })
              gsap.to(circleEls[bubbleIdx], {
                duration: 0.2,
                delay: 0.5 * dur,
                scale: 0,
                opacity: 0,
              })
              backgroundVisible = false
            })
          }
        })
      }
    }
    window.isRenderedOnce = true
  })

  return id ? (
    <a
      href={postData.info.permalink}
      className={classname}
      data-scroll
      target={`${permalink_target ? '_blank' : '_self'}`}
    >
      <div className="preview">
        <svg
          className="preview-back"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 0 0"
        ></svg>
        <div className="preview-body"></div>
      </div>
      <div className={'article-post__img-wrap'}>
        <img
          src={postData.info.thumbnail}
          className={'article-post__thumbnail'}
        />
      </div>
      <h5
        className={'article-post__title'}
        dangerouslySetInnerHTML={{ __html: postData.info.title }}
      />
      {typeof postData.info.excerpt === 'string' ? (
        <>
          <p className={'article-post__excerpt'}>
            <span
              dangerouslySetInnerHTML={{ __html: postData.info.excerpt }}
            ></span>
            <span className="article-post__permalink">
              {__(permalink_text)}
            </span>
          </p>
        </>
      ) : (
        <>
          <p className={'article-post__excerpt'}>
            {postData.info.excerpt}
            <span className="article-post__permalink">
              {__(permalink_text)}
            </span>
          </p>
        </>
      )}
    </a>
  ) : (
    false
  )
}
